export function isExternalCoverageActive(
  effectiveDate?: Date | number,
  endDate?: Date | number
) {
  if (!effectiveDate) return false;
  const now = new Date().getTime();
  const coverageEffectiveDate =
    typeof effectiveDate === "number" ? effectiveDate : effectiveDate.getTime();
  const coverageEndDate = !endDate
    ? Infinity
    : typeof endDate === "number"
      ? endDate
      : endDate.getTime();
  return (
    (now >= coverageEffectiveDate && now <= coverageEndDate) ||
    (now <= coverageEffectiveDate && now <= coverageEndDate)
  );
}
export default isExternalCoverageActive;
